import React, { useState } from "react";
import BackgroundCover from "../../components/backgroundCover/BackgroundCover";
import { ReactComponent as LocationIcon } from "../../assets/location.svg";
import StoreMaps from "./StoreMaps";
import { isMobile } from "../../utils/appUtils";
import { useLanguage } from '../../context/LanguageContext';
import { storesTemplateTranslations } from '../../translations/storesTemplate';

interface Store {
  id: number;
  name: string;
  country: string;
  address: {
    storeName: string;
    street: string;
    city: string;
    postalCode: string;
    phone: string;
    email: string;
  };
  lat: number;
  lng: number;
}

const STORES_DATA: Store[] = [
  {
    id: 1,
    name: "bayreuth",
    country: "Germany",
    address: {
      storeName: "Juwelier Böhnlein",
      street: "Maximilianstraße 25",
      city: "Bayreuth",
      postalCode: "95444",
      phone: "0921-507 01 60",
      email: "info@juwelier-boehnlein.de"
    },
    lat: 49.9456,
    lng: 11.5713
  },
  {
    id: 2,
    name: "bamberg",
    country: "Germany",
    address: {
      storeName: "Juwelier Böhnlein",
      street: "Grüner Markt 2",
      city: "Bamberg",
      postalCode: "96047",
      phone: "0951-519 30 00",
      email: "bamberg@juwelier-boehnlein.de"
    },
    lat: 49.8988,
    lng: 10.9028
  },
  {
    id: 3,
    name: "coburg",
    country: "Germany",
    address: {
      storeName: "Juwelier Böhnlein",
      street: "Mohrenstraße 36",
      city: "Coburg",
      postalCode: "96450",
      phone: "09561-755 25",
      email: "coburg@juwelier-boehnlein.de"
    },
    lat: 50.2615,
    lng: 10.9628
  },
  {
    id: 4,
    name: "chemnitz",
    country: "Germany",
    address: {
      storeName: "Juwelier Böhnlein",
      street: "Straße der Nationen 2-4",
      city: "Chemnitz",
      postalCode: "09111",
      phone: "0371-909 79 37",
      email: "chemnitz@juwelier-boehnlein.de"
    },
    lat: 50.8322,
    lng: 12.9242
  },
  {
    id: 5,
    name: "heilbronn",
    country: "Germany",
    address: {
      storeName: "Juwelier Böhnlein",
      street: "Fleiner Straße 32",
      city: "Heilbronn",
      postalCode: "74072",
      phone: "07131-684 05",
      email: "heilbronn@juwelier-boehnlein.de"
    },
    lat: 49.1426,
    lng: 9.2209
  },
  {
    id: 6,
    name: "berlin",
    country: "Germany",
    address: {
      storeName: "Chic Choc Berlin",
      street: "Holsteinische Straße 42",
      city: "Berlin",
      postalCode: "10717",
      phone: "+49 30 8738111",
      email: "info@chicchoc.de"
    },
    lat: 52.5200,
    lng: 13.4050
  },
  {
    id: 7,
    name: "strasslach",
    country: "Germany",
    address: {
      storeName: "Esther Gerzer Goldschmiede",
      street: "Grünwalderstraße 3",
      city: "Straßlach",
      postalCode: "82064",
      phone: "+49 8170 / 9986861",
      email: "info@esther-gerzer.com"
    },
    lat: 48.0159,
    lng: 11.4987
  },
  {
    id: 8,
    name: "munich",
    country: "Germany",
    address: {
      storeName: "JUWELENSCHMIEDE THOMAS JIRGENS",
      street: "AM KOSTTOR 1",
      city: "MÜNCHEN",
      postalCode: "80331",
      phone: "+49 89 29 162 152",
      email: "info@juwelenschmiede.de"
    },
    lat: 48.1351,
    lng: 11.5820
  },
  {
    id: 9,
    name: "hamburg",
    country: "Germany",
    address: {
      storeName: "Juwelier Waßmann",
      street: "Neuer Wall 26",
      city: "Hamburg",
      postalCode: "20354",
      phone: "040-367977",
      email: "juwelierwassmann@web.de"
    },
    lat: 53.5511,
    lng: 9.9937
  },
  {
    id: 10,
    name: "zwiesel",
    country: "Germany",
    address: {
      storeName: "Schierer Uhren und Optik",
      street: "Dr.-Schott Str. 15",
      city: "Zwiesel",
      postalCode: "94227",
      phone: "(09922)802576",
      email: "schierer@uhren-optik.de"
    },
    lat: 49.0147,
    lng: 13.2333
  },
  {
    id: 11,
    name: "zug",
    country: "Switzerland",
    address: {
      storeName: "Lauener Uhren & Schmuck",
      street: "Bahnhofstrasse 18",
      city: "Zug",
      postalCode: "6300",
      phone: "+41 41 7101855",
      email: "info@lauener-zug.ch"
    },
    lat: 47.1662,
    lng: 8.5155
  },
  {
    id: 12,
    name: "vienna",
    country: "Austria",
    address: {
      storeName: "ROZET & FISCHMEISTER",
      street: "Kohlmarkt 11",
      city: "Wien",
      postalCode: "1010",
      phone: "+43 1 533 80 61",
      email: "office@rozetundfischmeister.at"
    },
    lat: 48.2082,
    lng: 16.3719
  }
];

const Stores: React.FC = () => {
  const [selectedStore, setSelectedStore] = useState(STORES_DATA[0]);
  const { language } = useLanguage();
  const t = storesTemplateTranslations[language];

  const handleStoreChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const store = STORES_DATA.find((store) => store.name === selectedValue);
    if (store) {
      setSelectedStore(store);
    }
  };

  return (
    <div className="w-full min-h-screen bg-white">
      <BackgroundCover
        backgroundHeight={400}
        backgroundImage={"/images/stores_background.jpg"}
        imagePosition='initial'
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-4">
          {t.pageTitle}
        </h1>
        <p className="text-sm md:text-lg text-center text-gray-600 mb-8">
          {t.subtitle}
        </p>
        <div className="w-full h-px bg-gray-200 mb-8"></div>

        <div className="mb-12">
          <select
            id="store-selector"
            value={selectedStore.name}
            onChange={handleStoreChange}
            className="w-full md:w-auto mx-auto block px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            {STORES_DATA.map((store) => (
              <option key={store.id} value={store.name}>
                {store.address.storeName} - {store.address.city}
              </option>
            ))}
          </select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {STORES_DATA.map((store) => (
            <div
              key={store.id}
              className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200"
            >
              <div className="space-y-2">
                <h3 className="flex items-center text-lg font-medium text-gray-900 mb-4">
                  <LocationIcon className="w-5 h-5 mr-2 text-blue-500" />
                  {store.address.storeName}
                </h3>
                <p className="text-gray-600">{store.address.street}</p>
                <p className="text-gray-600">{store.address.postalCode} {store.address.city}</p>
                <p className="text-gray-600">{store.country}</p>
                <p className="text-gray-600 hover:text-blue-600">
                  <a href={`tel:${store.address.phone}`}>{store.address.phone}</a>
                </p>
                <p className="text-gray-600 hover:text-blue-600">
                  <a href={`mailto:${store.address.email}`}>{store.address.email}</a>
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <StoreMaps selectedStore={selectedStore} />
        </div>
      </div>
    </div>
  );
};

export default Stores;
